import React, { useState } from 'react';
import { ToastContainer } from "react-toastify";
import axios from "../../config/axios";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    Button,
    DialogActions,
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    Select,
    MenuItem,
    InputLabel,
    Box,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Checkbox, Grid
} from '@mui/material';
import ReactQuill from 'react-quill';
import FileUploader from '../FileUploader';
import InputAdornment from "@mui/material/InputAdornment";
import './NewsEvents.css';

import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { useTranslation } from 'react-i18next';

dayjs.extend(utc);
dayjs.extend(timezone);

const timezones = [
    { label: "(UTC-05:00) Eastern Time (US & Canada)", value: "America/New_York" },
    { label: "(UTC-08:00) Pacific Time (US & Canada)", value: "America/Los_Angeles" },
    { label: "(UTC-06:00) Central Time (US & Canada)", value: "America/Texas" },
    { label: "(UTC+00:00) Greenwich Mean Time", value: "GMT" },
    { label: "(UTC+01:00) Central European Time", value: "CET" },
];
const areas = [
    { label: "Healthcare", value: "Healthcare" },
    { label: "Education", value: "Education" },
    { label: "Motor Skills", value: "Motor Skills" },
    { label: "Cognitive Psychology", value: "Cognitive Psychology" },
    { label: "Mental Health (EQ)", value: "Mental Health (EQ)" },
    { label: "Occupational Therapy", value: "Occupational Therapy" },
    { label: "Physical Therapy", value: "Physical Therapy" },
    { label: "Reading", value: "Reading" },
    { label: "Writing", value: "Writing" },
    { label: "Speech & Language", value: "Speech & Language" },
];

function AddNewsEvents({ date, setDate, token, user, onEventCreated, onNewsCreated }) {
    const { t } = useTranslation();
    const [eventsModal, setEventsModal] = useState(false);
    const [newsModal, setNewsModal] = useState(false);

    const [thumbnail, setThumbnail] = useState(null);
    const [file, setFile] = useState(null);
    const [title, setTitle] = useState('');
    const [subtitle, setSubtitle] = useState('');
    const [ageRange, setAgeRange] = useState({ start: '', end: '' });
    const [eventTimezone, setEventTimezone] = useState(timezones[0].value);
    const [endDate, setEndDate] = useState();
    const [quillValue, setQuillValue] = useState('');
    const [capacity, setCapacity] = useState(0);
    const [itemsTable, setItemsTable] = useState(false);
    const [items, setItems] = useState([]);
    const [eventLocation, setEventLocation] = useState('in-person');
    const [meetingLink, setMeetingLink] = useState('');
    const [country, setCountry] = useState('');
    const [stateProvince, setStateProvince] = useState('');
    const [city, setCity] = useState('');
    const [streetAddress, setStreetAddress] = useState('');
    const [zipcode, setZipcode] = useState(0);
    const [price, setPrice] = useState('');
    const [sponsor, setSponsor] = useState('');
    const [area, setArea] = useState([]);
    const [classification, setClassification] = useState('screening');
    const [eventType, setEventType] = useState('Social Event');

    const handleImageUpload = (file) => {
        const firstFile = file[0];

        if (firstFile instanceof Blob || firstFile instanceof File) {
            setThumbnail(firstFile);
            console.log('Uploaded file:', firstFile);
        } else {
            console.error('Invalid file:', file);
        }
    };

    const fileTypes = [
        'image/*',
        'video/*',
        'audio/*',
        '.pdf',
        '.doc',
        '.docx',
        '.xml',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordpressingml.document'
    ];

    const addItemRow = () => {
        setItems([...items, { item: '', number: '', measurement: '' }]);
    };
    const deleteItemRow = () => {
        let tempArr = [...items];
        let index = tempArr.length - 1;
        tempArr.splice(index, 1);
        setItems(tempArr);
    };
    const handleItemsTable = () => {
        setItemsTable(!itemsTable);
        if (items === undefined || items.length === 0) {
            addItemRow();
        }
    }
    const updateItemsData = (index, field, value) => {
        const newItems = [...items];
        newItems[index][field] = value;
        setItems(newItems);
    };

    const handleOpenEventsPopup = () => {
        setEventsModal(true);
    };
    const handleCloseEventsPopup = () => {
        setEventsModal(false);
    };
    const handleChangeArea = (event) => {
        const value = event.target.value;
        setArea(typeof value === 'string' ? value.split(',') : value);
    };

    const handleCreateEvent = () => {
        // Validate required fields
        if (!title) {
            alert('Please enter a title for the event');
            return;
        }
        if (!endDate) {
            alert('Please select an end date and time for the event');
            return;
        }
        if (!date) {
            alert('Please select a start date and time for the event');
            return;
        }

        const event = {
            thumbnail: thumbnail,
            file: file,
            title: title,
            date: { startDate: date, endDate: endDate },
            body: quillValue,
            capacity: capacity,
            items: items,
            location: eventLocation,
            address: streetAddress,
            city: city,
            stateProvince: stateProvince,
            country: country,
            zipcode: zipcode,
        }

        const dayDiff = endDate.diff(date, 'minute');
        if (dayDiff > 1440) {
            alert('Event duration must be within a day or less');
        } else {
            const minutes = endDate.diff(event.date.startDate, 'minute');
            const newMinutes = minutes % 60;

            const hours = Math.floor(minutes / 60);
            const newHours = hours % 24;

            const days = Math.floor(hours / 24);
            const newDays = days % 30;

            const months = Math.floor(days / 30);
            const newMonths = months % 12;

            const years = Math.floor(months / 12);

            // Build duration in PostgreSQL interval format: "X days Y hours Z minutes"
            var durationParts = [];
            if (years > 0) {
                durationParts.push(`${years} years`);
            }
            if (newMonths > 0) {
                durationParts.push(`${newMonths} months`);
            }
            if (newDays > 0) {
                durationParts.push(`${newDays} days`);
            }
            if (newHours > 0) {
                durationParts.push(`${newHours} hours`);
            }
            if (newMinutes > 0) {
                durationParts.push(`${newMinutes} minutes`);
            }
            // Default to 0 minutes if no duration
            var duration = durationParts.length > 0 ? durationParts.join(' ') : '0 minutes';

            axios({
                method: 'post',
                url: '/event',
                data: {
                    'title': event.title,
                    'body': event.body,
                    'capacity': event.capacity ? parseInt(event.capacity) : 0,
                    'eventType': event.location,
                    'eventLink': meetingLink || '',
                    'eventTimestamp': (event.date.startDate).format('YYYY-MM-DD HH:mm:ss'),
                    'duration': duration,
                    'eventAddress': {
                        'street': event.address || '',
                        'city': event.city || '',
                        'state': event.stateProvince || '',
                        'country': event.country || '',
                        'zipcode': event.zipcode ? parseInt(event.zipcode) : 0,
                    }
                },
                headers: {
                    'token': token,
                    'Content-Type': 'application/json'
                }
            }).then((response) => {
                console.log('Created Event = ', response.data);

                const postEvent = response.data;
                const eventId = postEvent.id;

                if (user?.authRole === 'admin') {
                    for (let i = 0; i < event.items.length; i++) {
                        axios({
                            method: 'post',
                            url: `/user/event/${eventId}/item`,
                            data: {
                                "name": event.items[i].item,
                                "quantity": event.items[i].number
                            },
                            params: {
                                eventId: eventId
                            },
                            headers: {
                                'token': token,
                                'Content-Type': 'application/json'
                            }
                        }).then((response) => {
                            console.log('Added Item(s) to Event = ', response.data);
                        }).catch(error => {
                            console.error(error);
                        });
                    }

                    if (thumbnail) {
                        axios({
                            method: 'put',
                            url: `/user/event/${eventId}/photo`,
                            data: {
                                photo: event.thumbnail
                            },
                            headers: {
                                'token': token,
                                'Content-Type': 'multipart/form-data'
                            }
                        }).then((response) => {
                            console.log('Added Thumbnail Photo to Event = ', response.data);
                        }).catch(error => {
                            console.error(error);
                        });
                    }

                    if (file) {
                        axios({
                            method: 'put',
                            url: `/user/event/${eventId}/file`,
                            data: {
                                file: event.file
                            },
                            headers: {
                                'token': token,
                                'Content-Type': 'multipart/form-data'
                            }
                        }).then((response) => {
                            console.log('Added File to Event = ', response.data);
                        }).catch(error => {
                            console.error(error);
                        });
                    }
                }

                console.log('Event = ', event);
                alert('Event created successfully!');
                handleCloseEventsPopup();
                // Refresh the page to show the new event
                window.location.reload();
            }).catch(error => {
                console.error('Event creation error:', error);
                const errorMessage = error.response?.data?.message || error.message || 'Unknown error';
                alert(`Failed to create event: ${errorMessage}`);
            });
        }
    };

    const handleOpenNewsPopup = () => {
        setNewsModal(true);
    };
    const handleCloseNewsPopup = () => {
        setNewsModal(false);
    };
    const handleCreateNews = () => {
        // Validate required fields
        if (!title) {
            alert('Please enter a title for the news article');
            return;
        }
        if (!date) {
            alert('Please select a date for the news article');
            return;
        }

        const news = {
            photo: thumbnail,
            title: title,
            subtitle: subtitle,
            date: date,
            body: quillValue,
            city: city,
            state: stateProvince,
            country: country,
        }

        axios({
            method: 'post',
            url: '/news',
            data: {
                "title": news.title,
                "body": news.body,
                "newsTimestamp": news.date,
                "newsAddress": {
                    "city": news.city,
                    "state": news.state,
                    "country": news.country
                },
            },
            headers: {
                'token': token,
            }
        }).then((response) => {
            console.log('Created News = ', response.data);

            const postNews = response.data;
            const newsId = postNews.id;

            if (user?.authRole === 'admin') {
                if (thumbnail) {
                    axios({
                        method: 'put',
                        url: `/user/news/${newsId}/photo`,
                        data: {
                            photo: news.photo
                        },
                        headers: {
                            'token': token,
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then((response) => {
                        console.log('Added Photo to News = ', response.data);
                    }).catch(error => {
                        console.error(error);
                    });
                }
            }

            console.log('News = ', news);
            alert('News article created successfully!');
            handleCloseNewsPopup();
            // Refresh the page to show the new news
            window.location.reload();
        }).catch(error => {
            console.error(error);
            alert('Failed to create news article. Please try again.');
        });
    };

    var fileType;
    if (file) {
        const searchChar = '.';
        var indexOfStr = file.name.lastIndexOf(searchChar);
        fileType = file.name.slice(indexOfStr, file.name.length);
    }

    return (
        <div className="app">
            <ToastContainer />
            {
                (token && user?.authRole === 'admin') &&
                <>
                    <Grid container justifyContent={'space-evenly'} sx={{ marginTop: '1rem', marginBottom: '1rem' }}>
                        <Button
                            variant="outlined"
                            className={'purpleButton'}
                            onClick={handleOpenEventsPopup}
                            sx={{
                                color: '#6750A4',
                                borderColor: '#6750A4',
                                '&:hover': {
                                    backgroundColor: 'rgba(103, 80, 164, 0.1)',
                                    borderColor: '#6750A4',
                                }
                            }}
                        >
                            {t('EventsPage.NewsEvents.AddEvent')}
                        </Button>
                        <Button
                            variant="outlined"
                            className={'purpleButton'}
                            onClick={handleOpenNewsPopup}
                            sx={{
                                color: '#6750A4',
                                borderColor: '#6750A4',
                                '&:hover': {
                                    backgroundColor: 'rgba(103, 80, 164, 0.1)',
                                    borderColor: '#6750A4',
                                }
                            }}
                        >
                            {t('EventsPage.NewsEvents.AddNews')}
                        </Button>
                    </Grid>

                    <Dialog open={eventsModal} onClose={handleCloseEventsPopup} fullWidth={true} maxWidth={'md'}
                        aria-labelledby="form-dialog-title">
                        <DialogTitle id="form-dialog-title">{t('EventsPage.NewsEvents.CreateEvent')}</DialogTitle>
                        <DialogContent>
                            <Box sx={{ width: 'auto' }}>
                                <FileUploader onFilesUploaded={handleImageUpload} />
                                <FormControl>
                                    <label htmlFor={'file'}>{t('EventsPage.NewsEvents.UploadFile')}</label>
                                    {file
                                        ? <Grid container alignItems={'center'}>
                                            {file.name.slice(0, 30) + '....' + fileType}
                                            <Button onClick={() => setFile(null)}>
                                                {t('EventsPage.NewsEvents.RemoveFile')}
                                            </Button>
                                        </Grid>
                                        : <input type={'file'} id={'file'} name={'file'} accept={fileTypes}
                                            onChange={(e) => setFile(e.target.files[0])} />
                                    }
                                </FormControl>

                                <TextField
                                    autoFocus
                                    margin="dense"
                                    id="title"
                                    label={t('EventsPage.NewsEvents.Title')}
                                    type="text"
                                    fullWidth
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                />
                                <TextField
                                    margin="dense"
                                    id="subtitle"
                                    label={t('EventsPage.NewsEvents.Subtitle')}
                                    type="text"
                                    fullWidth
                                    value={subtitle}
                                    onChange={(e) => setSubtitle(e.target.value)}
                                />

                                <Box sx={{
                                    marginBottom: '1rem', display: "flex", alignItems: "center", gap: '2'
                                }}>
                                    <TextField
                                        fullWidth={true}
                                        margin="dense"
                                        id="ageRangeStart"
                                        label={t('EventsPage.NewsEvents.AgeStart')}
                                        type="number"
                                        value={ageRange.start}
                                        onChange={(e) => setAgeRange({ ...ageRange, start: e.target.value })}
                                    />
                                    <Box>{t('EventsPage.NewsEvents.To')}</Box>
                                    <TextField
                                        fullWidth={true}
                                        margin="dense"
                                        id="ageRangeEnd"
                                        label={t('EventsPage.NewsEvents.AgeEnd')}
                                        type="number"
                                        value={ageRange.end}
                                        onChange={(e) => setAgeRange({ ...ageRange, end: e.target.value })}
                                    />
                                </Box>

                                <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', columnGap: 2, }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DateTimePicker
                                            label={t('EventsPage.NewsEvents.StartDate')}
                                            value={date}
                                            minDate={dayjs(Date.now())}
                                            onChange={(newValue) => { setDate(newValue) }}
                                            renderInput={(params) => <TextField {...params} fullWidth />}
                                        />
                                    </LocalizationProvider>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DateTimePicker
                                            label={t('EventsPage.NewsEvents.EndDate')}
                                            value={endDate}
                                            onChange={(newValue) => setEndDate(newValue)}
                                            renderInput={(params) => <TextField {...params} fullWidth />}
                                        />
                                    </LocalizationProvider>
                                </Box>

                                <FormControl fullWidth margin="dense">
                                    <Select
                                        labelId="time-zone-select-label"
                                        id="time-zone-select"
                                        value={eventTimezone}
                                        label={t('EventsPage.NewsEvents.TimeZone')}
                                        onChange={(e) => setEventTimezone(e.target.value)}
                                    >
                                        {timezones.map((tz) => (
                                            <MenuItem key={tz.value} value={tz.value}>{tz.label}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                                <Box>
                                    <label>{t('EventsPage.NewsEvents.Description')}</label>
                                    <Box>
                                        <ReactQuill
                                            modules={{ toolbar: false }}
                                            value={quillValue}
                                            onChange={setQuillValue}
                                            style={{ height: "125px" }}
                                        />
                                    </Box>
                                </Box>

                                <TextField
                                    margin="dense"
                                    id="capacity"
                                    label={t('EventsPage.NewsEvents.Capacity')}
                                    type="number"
                                    fullWidth
                                    value={capacity}
                                    onChange={(e) => setCapacity(e.target.value)}
                                />

                                <Box>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={itemsTable}
                                                onClick={handleItemsTable}
                                            />
                                        }
                                        label={t('EventsPage.NewsEvents.CreateTable')}
                                    />
                                </Box>
                                {itemsTable &&
                                    (<Box display="flex" justifyContent="space-between" alignItems="start">
                                        <TableContainer component={Paper}>
                                            <Table aria-label="Items table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>{t('EventsPage.NewsEvents.ItemName')}</TableCell>
                                                        <TableCell>{t('EventsPage.NewsEvents.ItemNumber')}</TableCell>
                                                        <TableCell>{t('EventsPage.NewsEvents.ItemMeasurement')}</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {items.map((item, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell>
                                                                <TextField
                                                                    value={item.item}
                                                                    onChange={(e) => updateItemsData(index, 'item', e.target.value)}
                                                                />
                                                            </TableCell>
                                                            <TableCell>
                                                                <TextField
                                                                    type={'number'}
                                                                    value={item.number}
                                                                    onChange={(e) => updateItemsData(index, 'number', e.target.value)}
                                                                />
                                                            </TableCell>
                                                            <TableCell>
                                                                <Select value={item.measurement}
                                                                    onChange={(e) => updateItemsData(index, 'measurement', e.target.value)}>
                                                                    <MenuItem value={'lbs'}>{'lbs'}</MenuItem>
                                                                    <MenuItem value={'kg'}>{'kg'}</MenuItem>
                                                                    <MenuItem value={'pcs'}>{'pcs'}</MenuItem>
                                                                </Select>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                        <Button onClick={addItemRow}>{t('EventsPage.NewsEvents.AddRow')}</Button>
                                        <Button onClick={deleteItemRow}>{t('EventsPage.NewsEvents.DeleteRow')}</Button>
                                    </Box>
                                    )}
                                <Box>
                                    <FormControl component="fieldset">
                                        <FormLabel component="legend">{t('EventsPage.NewsEvents.Location')}</FormLabel>
                                        <RadioGroup row name="eventLocation" value={eventLocation}
                                            onChange={(e) => setEventLocation(e.target.value)}>
                                            <FormControlLabel value="in-person" control={<Radio />} label={t('EventsPage.NewsEvents.InPerson')} />
                                            <FormControlLabel value="hybrid" control={<Radio />} label={t('EventsPage.NewsEvents.Hybrid')} />
                                            <FormControlLabel value="online" control={<Radio />} label={t('EventsPage.NewsEvents.Remote')} />
                                        </RadioGroup>
                                    </FormControl>
                                </Box>

                                {eventLocation !== "in-person" &&
                                    (<TextField
                                        id="meetingLink"
                                        label={t('EventsPage.NewsEvents.MeetingLink')}
                                        value={meetingLink}
                                        onChange={(e) => setMeetingLink(e.target.value)}
                                        fullWidth
                                        margin="dense"
                                    />)
                                }

                                {eventLocation !== "online" &&
                                    (<Box>
                                        <FormLabel component="legend">{t('EventsPage.NewsEvents.Address')}</FormLabel>
                                        <Box sx={{
                                            display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', columnGap: 2,
                                        }}>
                                            <Box>
                                                <TextField
                                                    id="country"
                                                    label={t('EventsPage.NewsEvents.Country')}
                                                    value={country}
                                                    onChange={(e) => setCountry(e.target.value)}
                                                    fullWidth
                                                />
                                            </Box>
                                            <Box>
                                                <TextField
                                                    id="stateProvince"
                                                    label={t('EventsPage.NewsEvents.StateProvince')}
                                                    value={stateProvince}
                                                    onChange={(e) => setStateProvince(e.target.value)}
                                                    fullWidth
                                                />
                                            </Box>
                                            <Box>
                                                <TextField
                                                    id="city"
                                                    label={t('EventsPage.NewsEvents.City')}
                                                    value={city}
                                                    onChange={(e) => setCity(e.target.value)}
                                                    fullWidth
                                                />
                                            </Box>
                                        </Box>
                                        <TextField
                                            id="streetAddress"
                                            label={t('EventsPage.NewsEvents.StreetAddress')}
                                            value={streetAddress}
                                            onChange={(e) => setStreetAddress(e.target.value)}
                                            fullWidth
                                            margin="dense"
                                        />
                                        <TextField
                                            id="zipcode"
                                            label={t('EventsPage.NewsEvents.Zipcode')}
                                            type={'number'}
                                            value={zipcode}
                                            onChange={(e) => setZipcode(e.target.value)}
                                            fullWidth
                                            margin="dense"
                                        />
                                    </Box>)
                                }
                                <TextField
                                    id="price"
                                    label={t('EventsPage.NewsEvents.Price')}
                                    type={'number'}
                                    value={price}
                                    onChange={(e) => setPrice(e.target.value)}
                                    fullWidth
                                    margin="dense"
                                    slotProps={{
                                        input: {
                                            startAdornment: <InputAdornment position={'start'}>$</InputAdornment>
                                        }
                                    }}
                                />
                                <TextField
                                    id="sponsor"
                                    label={t('EventsPage.NewsEvents.Sponsor')}
                                    value={sponsor}
                                    onChange={(e) => setSponsor(e.target.value)}
                                    fullWidth
                                    margin="dense"
                                />
                                <FormControl fullWidth margin="dense">
                                    <InputLabel id="area-label">{t('EventsPage.NewsEvents.Area')}</InputLabel>
                                    <Select
                                        labelId="area-label"
                                        id="area"
                                        multiple={true}
                                        value={area}
                                        label={t('EventsPage.NewsEvents.Area')}
                                        onChange={handleChangeArea}
                                    >
                                        {areas.map((area) => (
                                            <MenuItem key={area.value} value={area.value}>
                                                {area.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                                <FormControl component="fieldset">
                                    <FormLabel component="legend">{t('EventsPage.NewsEvents.Classification')}</FormLabel>
                                    <RadioGroup row name="classification" value={classification}
                                        onChange={(e) => setClassification(e.target.value)}>
                                        <FormControlLabel value="screening" control={<Radio />}
                                            label={t('EventsPage.NewsEvents.Screening')} />
                                        <FormControlLabel value="assessment" control={<Radio />} label={t('EventsPage.NewsEvents.Assessment')} />
                                        <FormControlLabel value="intervention" control={<Radio />} label={t('EventsPage.NewsEvents.Intervention')} />
                                        <FormControlLabel value="other" control={<Radio />} label={t('EventsPage.NewsEvents.Other')} />
                                    </RadioGroup>
                                </FormControl>

                                <FormControl component="fieldset">
                                    <FormLabel component="legend">{t('EventsPage.NewsEvents.Type')}</FormLabel>
                                    <RadioGroup row name="type" value={eventType}
                                        onChange={(e) => setEventType(e.target.value)}>
                                        <FormControlLabel value="Social Event" control={<Radio />} label={t('EventsPage.NewsEvents.SocialEvent')} />
                                        <FormControlLabel value="service" control={<Radio />} label={t('EventsPage.NewsEvents.Service')} />
                                        <FormControlLabel value="product" control={<Radio />} label={t('EventsPage.NewsEvents.Product')} />
                                        <FormControlLabel value="other" control={<Radio />} label={t('EventsPage.NewsEvents.Other')} />
                                    </RadioGroup>
                                </FormControl>
                            </Box>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseEventsPopup} color="primary">
                                {t('EventsPage.NewsEvents.Cancel')}
                            </Button>
                            <Button onClick={handleCreateEvent} color="primary">
                                {t('EventsPage.NewsEvents.CreateEvent')}
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog open={newsModal} onClose={handleCloseNewsPopup} fullWidth={true} maxWidth={'md'}
                        aria-labelledby="form-dialog-title">
                        <DialogTitle id="form-dialog-title">{t('EventsPage.NewsEvents.CreateNews')}</DialogTitle>
                        <DialogContent>
                            <Box>
                                <FileUploader onFilesUploaded={handleImageUpload} />
                                <Box sx={{ paddingBottom: '1em', display: 'grid', gridTemplateColumns: 'repeat(1, 1fr)' }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DateTimePicker
                                            label={t('EventsPage.NewsEvents.DateTime')}
                                            value={date}
                                            onChange={(newValue) => setDate(newValue)}
                                            renderInput={(params) => <TextField {...params} fullWidth />}
                                        />
                                    </LocalizationProvider>
                                </Box>

                                <TextField
                                    autoFocus
                                    margin="dense"
                                    id="title"
                                    label={t('EventsPage.NewsEvents.Title')}
                                    type="text"
                                    fullWidth
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                />

                                <TextField
                                    margin="dense"
                                    id="subtitle"
                                    label={t('EventsPage.NewsEvents.Subtitle')}
                                    type="text"
                                    fullWidth
                                    value={subtitle}
                                    onChange={(e) => setSubtitle(e.target.value)}
                                />

                                <Box>
                                    <label>{t('EventsPage.NewsEvents.Description')}</label>
                                    <Box>
                                        <ReactQuill
                                            modules={{ toolbar: false }}
                                            value={quillValue}
                                            onChange={setQuillValue}
                                            style={{ height: "125px" }}
                                        />
                                    </Box>
                                </Box>
                            </Box>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseNewsPopup} color="primary">
                                {t('EventsPage.NewsEvents.Cancel')}
                            </Button>
                            <Button onClick={handleCreateNews} color="primary">
                                {t('EventsPage.NewsEvents.CreateNews')}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </>
            }
        </div>
    );
}

export default AddNewsEvents;
